<script setup>
import Loader from '@/components/Loader/Loader.vue'

const localePath = useLocalePath()
const route = useRoute()

const errorContext = useError()
const showLoader = ref(false)

const errors = {
  400: {
    title: 'error.header100',
  },
  404: {
    photo: '/images/errors/404.svg',
    alt: 'error.alt4',
    title: 'error.header404',
    lead: 'error.lead404',
  },
  500: {
    photo: '/images/errors/500.svg',
    alt: 'error.alt5',
    title: 'error.header500',
    lead: 'error.lead500',
  },
}

const onClick = () => {
  const route = localePath('index')
  window.location.replace(`${window.location.origin}${route}`)
}

const error = computed(() => errors[errorContext?.value?.statusCode || 500])

watch(() => route.fullPath, () => {
  showLoader.value = true
  window.location.reload()
})

</script>

<template>
  <div :class="['error', `${showLoader ? 'error--loader' : ''}`]">
    <UiNavigation hide-lang />
    <div
      v-if="showLoader"
      class="error__container error__container--loader"
    >
      <Loader />
    </div>
    <div
      v-else
      class="error__container"
    >
      <div class="error__numberContainer">
        <img
          v-if="error.photo"
          class="error__image"
          :src="error.photo"
          :alt="$t(error.alt)"
        >
      </div>
  
      <div class="error__textContainer">
        <p
          class="error__title"
        >
          {{ $t(error.title) }}
        </p>

        <br>
        
        <p
          v-if="errorContext.status !== 400"
          class="error__title"
        >
          {{ errorContext }}
        </p>
        
        <p
          v-if="error.lead"
          class="error__lead"
        >
          {{ $t(error.lead) }}
        </p>
      </div>
  
      <button
        class="error__button"
        @click="onClick"
      >
        {{ $t('error.button') }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100vh;
  padding: 2.4rem;
  background-color: $purple-200;
  background-image: url('/images/errors/logo.svg');
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: 85%;

  &--loader {
    background: none;
  }

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 82px);
  }

  &__numberContainer {
    display: flex;
    gap: 0.6rem;
    margin: 18.5rem 0 1.9rem 0;
  }

  &__image {
    max-height: 10rem;
  }

  &__textContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 4rem;
  }

  &__title {
    margin-bottom: 4.1rem;
    color: $text-400;
    font-weight: 500;
    font-size: 2.8rem;
    line-height: 3.6rem;
    text-align: center;
    text-decoration: underline;
    text-decoration-color: $purple-400;
    text-decoration-thickness: 2px;
    text-underline-offset: 7px;
  }

  &__lead {
    color: $text-400;
    font-weight: 500;
    font-size: 1.8rem;
    line-height: 2.4rem;
    text-align: center;
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 12.8rem;
    width: auto;
    width: fit-content;
    height: 4.6rem;
    padding: 1.4rem 2.4rem;
    color: $white;
    font-size: 1.5rem;
    text-align: center;
    background-color: transparent;
    background-color: $text-400;
    border: 0;
    border-radius: 5rem;
    cursor: pointer;
  }
}

@include atM {
  .error {
    align-items: flex-start;
    padding-left: 12.4rem;
    background-size: unset;

    &__container {
      display: block;
      height: initial;

      &--loader {
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 12.4rem);
        height: 100%;
      }
    }

    &__numberContainer {
      margin: 31.8rem 0 4.8rem 0;
    }

    &__textContainer {
      align-items: flex-start;
    }

    &__image {
      max-height: none;
    }

    &__title {
      margin-bottom: 3.5rem;
      font-size: 4.8rem;
      line-height: 5.6rem;
    }
  }
}
</style>
